import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../../features/global/globalSlice";
import { Tabs } from "antd";
import ProjectList from "./project/ProjectList";
import DonorTable from "./donor/DonorTable";
import ComponentsTable from "./components/ComponentsTable";
import ActivityTable from "./activity/ActivityTable";
import IssueTable from "./issues/IssueTable";
import DocumentsList from "./documents/DocumentsList";
import PaymentTable from "./payment/PaymentTable";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import ProjectImages from "./project-images/ProjectImages";
import ProjectChat from "./chat/ProjectChat";

function OverviewTabList() {
  const url = "api/v2/dashboard/getProjectTitleCounts";
  const dispatch = useDispatch();
  const [active, setactive] = useState("1");

  const { loading, data, activeObjOngoingProject } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
  }));

  async function refetching(activeKey) {
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
    await fetchTableData();
  }

  const getTotalByCategory = (category) => {
    const item = data?.find((c) => c?.category === category);
    return item ? item?.total : 0;
  };
  const tabConfigurations = [
    {
      label: <span className="flex items-center">Project</span>,
      key: "1",
      children: <ProjectList />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Funders
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Funders")}
            </span>
          </span>
        </span>
      ),
      key: "2",
      children: <DonorTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Components
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Components")}
            </span>
          </span>
        </span>
      ),
      key: "3",
      children: <ComponentsTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Activity
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Activity")}
            </span>
          </span>
        </span>
      ),
      key: "4",
      children: <ActivityTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Issues
            <span
              className={`rounded-full ${
                getTotalByCategory("Issues") > 0
                  ? "bg-red-500 text-white"
                  : "bg-[#CECECE] "
              } w-[1.25rem] h-[1.25rem] flex items-center justify-center`}
            >
              {getTotalByCategory("Issues")}
            </span>
          </span>
        </span>
      ),
      key: "5",
      children: <IssueTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Documents
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Documents")}
            </span>
          </span>
        </span>
      ),
      key: "6",
      children: <DocumentsList />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Disbursement
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Disbursement")}
            </span>
          </span>
        </span>
      ),
      key: "7",
      children: <PaymentTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className="flex gap-x-[.62rem] items-center">
            Project Images
            <span className="rounded-full bg-[#CECECE] w-[1.25rem] h-[1.25rem] flex items-center justify-center">
              {getTotalByCategory("Project Images")}
            </span>
          </span>
        </span>
      ),
      key: "8",
      children: <ProjectImages />,
    },
    {
      label: <span className="flex items-center">Chat</span>,
      key: "9",
      children: <ProjectChat />,
    },
  ];

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        projectId: activeObjOngoingProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }
  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <div className="white_card mt-[2.06rem]">
      <Tabs
        items={tabConfigurations}
        defaultActiveKey="1"
        activeKey={active}
        onChange={refetching}
        className="activity-tab-wrap project-tab partner-bar !overflow-x-auto"
      />
    </div>
  );
}

export default OverviewTabList;
